<template>
    <ModalFormCard class="modal-default" :action='"/admin/actions/subscription/" + subscription.id + "/move-location"'>
        <template #title>Change {{ subscription.company.name }} location</template>

        <template #default="{ saving, errors }">
            <p class='text-15 font-semibold'>Change {{ subscription.location_area.name }} location</p>
            <p class='text-14 text-grey-900 mt-2'>
                Changing location can take a few days as the subscription will need to be rebuilt
            </p>

            <Select class='mt-4' name='reason'
                v-model:value='value.reason'
                placeholder='Reason'
                label='Reason for extension' 
                :options="[
                    { value: 'Poor performance' },
                    { value: 'Other' },
                ]" 
            />

            <Textarea name='reason_other' v-model:value='value.reason_other' 
                label='Other reason' v-if='value.reason == "Other"' 
                class='mt-4'
            /> 

            <Select
                selectClass="!bg-grey text-15" class='mt-4'
                menuClass="!bg-grey"
                name="location_area_id"
                label="Location"
                placeholder="Select your next area"
                v-model:value="value.location_area_id"
                :options="locations"
                :disabled="saving"
                @update:value="(id) => { this.$refs.googleMap.setActiveArea(this.areas.find((a) => a.id == id)) }"
            >
                <template #option='{ option, selected }'>
                    <p :class='[ option.location.available ? "" : "text-red-700" ]'>{{ option.html }}</p>
                </template>
            </Select>

            <div class="w-full bg-grey-400 mt-6" style="height: 308px" 
                v-if='areas != null && areas.length > 0'
            >
                <GoogleMap
                    v-if="value.location_area_id != null && areas != null"
                    :areas="areas"
                    :area="parseInt(value.location_area_id)"
                    ref="googleMap"
                    @setArea="(id) => { value.location_area_id = id }"
                />
            </div>

            <InputCheckbox class='mt-4' name="accepted" value="1">
                <p class="text-14 text-grey-900 pl-2">
                    Are you sure you want to move from {{ subscription.location_area.name }} 
                    to {{ newLocation.name }}?
                </p>
            </InputCheckbox>

            <div class="modal-buttons pt-6">
                <ButtonSaving :disabled="saving" class="default button-black h-12 px-6">
					Change location
				</ButtonSaving>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
    import Modal from '~/mixins/modal.js'
    import GoogleMap from '~/components/customer/blocks/google-map-old.vue'

    export default {
        mixins: [Modal],

        data() {
            return {
                areas: null,
                value: {
                    reason: null,
                    reason_other: '',
                    location_area_id: null
                }
            }
        },

        created() {
            this.getLocations();
        },

        methods: {
            getLocations() {
                this.$axios
                    .post('/actions/subscription-locations-for-trade', {
                        industry_id: this.subscription.company.industry_id,
                        product_id: this.subscription.product_id,
                        company_id: this.subscription.company_id
                    })
                    .then((res) => {
                        this.areas = res.areas

                        this.value.location_area_id = this.areas[0].id
                    })
            },
        },

        computed: {
            subscription() {
                return this.editingModel
            },

            locations() {
                if (this.areas == null) {
                    return []
                }

                return this.areas.map((l) => {
                    return {
                        value: l.id,
                        html: this.$help.capitalizeFirstLetter(l.name),
                        location: l
                    }
                })
            },

            newLocation() {
                if (this.areas == null) {
                    return { name: 'n\a' }
                }

                return this.areas.find(a => a.id == this.value.location_area_id)
            }
        },

        components: {
            GoogleMap
        }
    }
</script>